export default __webpack_public_path__ + "locales/de/UploadPanel.json?hash=46d0d7c2f0a1810432a50e296173f65c";